import { accessGrantApi } from "@infrastructure/api";
import { AccessGrantSchema, AccessGrantCreationSchema, } from "../models";
// =============================================================================
// MAPPING
// =============================================================================
function toAccessGrant(dto) {
    return AccessGrantSchema.parse(dto);
}
function toAccessGrantCreation(dto) {
    return AccessGrantCreationSchema.parse(dto);
}
// =============================================================================
// IMPLEMENTATION
// =============================================================================
export const accessGrantRepository = {
    async list(orgId) {
        const response = await accessGrantApi.list(orgId);
        return response.data.data.map(toAccessGrant);
    },
    async create(orgId, allowedOrigins, captchaRequired) {
        const response = await accessGrantApi.create(orgId, allowedOrigins, captchaRequired);
        return toAccessGrantCreation(response.data.data);
    },
    async revoke(orgId, grantId) {
        await accessGrantApi.revoke(orgId, grantId);
    },
};
export default accessGrantRepository;
